import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * The one ask every content page ends on: the money gap that's left after
 * grants and budgeting is what a fund page is for. Kept as one component so the
 * fee wording can't drift between pages (see SOCIAL_STRATEGY.md's accuracy
 * guardrail: the fee is added on top for the supporter, never taken out).
 */
export function FundTheGapCTA({
  title = 'Cover the rest with a free fund page',
  body = "Grants and budgeting rarely close the whole gap. A Sport Fund page lets family, friends and local supporters back your athlete once or every month — free for athletes, and 100% of every donation reaches them (the small fee is added on top for the supporter, never taken out).",
}: {
  title?: string;
  body?: string;
}) {
  return (
    <div className="not-prose my-10 rounded-3xl bg-[#070b18] p-8 md:p-10 text-white ring-1 ring-white/10">
      <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight">{title}</h2>
      <p className="mt-3 text-slate-300 leading-relaxed max-w-2xl">{body}</p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <Link
          to="/signup-creator"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 hover:bg-yellow-300 text-slate-900 px-6 py-3 font-semibold transition-colors"
        >
          Start a free fund page <ArrowRight className="h-4 w-4" />
        </Link>
        <Link
          to="/parent-plus"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 hover:bg-white/10 px-6 py-3 font-medium transition-colors"
        >
          Estimate your season's gap
        </Link>
      </div>
    </div>
  );
}
